//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class RuleModel extends ModelBase {
      static readonly $typeName = 'RuleModel';
      public collectionName: string;
      public dataSetName: string;
      public disableReason: string;
      public entityName: string;
      public isEnabled: boolean;
      public ruleName: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/businessRule/models/RuleModel.ts